var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yj-frame-main"},[_c('div',{staticClass:"up-banner"},[_c('div',{staticClass:"product"},[_c('h3',[_c('typed-ment',{attrs:{"id":"bczn","strings":"趸船智能管理系统"}})],1),_c('h4',[_vm._v("联系我们")]),_c('contact-us')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }